import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { EMPTY, Observable, Subscription } from 'rxjs';
import { DataService } from '../shared/common-services/data.service';
import { LoaderHandlerService } from '../shared/common-services/overlay-loader-service/loader-handler.service';
import { ApiConstants } from './endpointsAndGeneric-constants/api-constants';

@Injectable({
  providedIn: 'root'
})
export class HttpMethodModifierService {

  private _subscription: Subscription;
  private _sessionTimeoutFlag: boolean = false;

  constructor(private http: HttpClient, private loaderHandler: LoaderHandlerService, private _dataService: DataService) {
    this._subscription = this._dataService?.events?.subscribe((res: any) => {
      if (res.name === 'sessionTimeout') {
        this._sessionTimeoutFlag = true;
      }
    });
  }

  httpReq(reqType: string, baseURL: string, endURL: string, data?: any, loaderNeeded: boolean = true): Observable<any> {
    if (!this._sessionTimeoutFlag) {
      let fullURL = ApiConstants?.API_ENDPOINT + endURL;
      if (loaderNeeded) {
        this.loaderHandler.toggleLoader(1);
      }
      if (baseURL === 'azureBlobBaseUrl') { fullURL = endURL; }
      switch (reqType) {
      case 'get':
        const getURL = data ? fullURL + data : fullURL;
        return this.http.get(getURL);
      case 'get-text-type':
        const getTextURL = data ? fullURL + data : fullURL;
        return this.http.get(getTextURL, { responseType: 'text', observe: 'response' });
      case 'post':
        return this.http.post(fullURL, data);
      case 'put':
        return this.http.put(fullURL, data, { observe: 'events', reportProgress: true });
      case 'delete':
        return this.http.delete(fullURL, { observe: 'response' });
      case 'patch':
        return this.http.patch(fullURL, data);
      default: return this.http.post(fullURL, data, { responseType: 'blob' });
      }
    } else {
      return EMPTY;
    }
  }
}